/**
 * The Serious System "Option" row, drawn the same way by the composer's "+" menu and by a connector's
 * `...` menu (Figma: Composer - Dropdown 12891-31731, MCP - More Options 12866-30909): 40px tall,
 * 16px side padding, 8px gap, P3 text, rounded-lg.
 *
 * The highlight is hover or keyboard focus only: the CDK menu focuses its first item on open, and a
 * mouse-opened menu should rest with nothing highlighted.
 *
 * Neither `sd-dropdown-menu` nor `sd-option-menu` draws this row — both are 48-56px and semibold — so
 * the two menus build on the CDK primitives instead and share these metrics from here.
 */
const OPTION_ROW_BASE = `
  flex items-center gap-2 w-full h-10 px-4 rounded-lg text-left
  typo-p3 leading-5
  hover:bg-neutral-100 focus-visible:bg-neutral-100 focus:outline-hidden
  disabled:cursor-not-allowed disabled:hover:bg-transparent
`;

export const OPTION_ROW_CLASS = `
  ${OPTION_ROW_BASE}
  text-neutral-700 disabled:text-neutral-400
`;

/** The destructive row of a menu (Figma: Option/Desktop/Error/On) — same metrics, error label. */
export const OPTION_ROW_ERROR_CLASS = `
  ${OPTION_ROW_BASE}
  text-error-600 hover:bg-error-50 focus-visible:bg-error-50
`;
